import {
    useMemo,
} from 'react'
import {
    useLocation, useSearchParams,
} from 'react-router-dom'

import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import {
    Company,
} from 'app/Apps/ContactManagement/Companies/Companies.types'
import requests from 'app/requests/BillingCompany.requests'
import BillingCompanyForm from '../BillingCompanyForm'
import {
    BillingCompany,
} from '../BillingCompanyForm.types'

const BillingCompanyCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const {
        search,
        state,
    } = useLocation()

    const [searchParams] = useSearchParams(search)

    const defaultData = useMemo(() => {
        const id = searchParams?.get('companyId') || state?.company?.id

        return (id ? {
            company: {
                id,
            } as unknown as Company,
        } : {}) as BillingCompany
    }, [
        state?.company?.id,
        searchParams,
    ])

    return (
        <BillingCompanyForm
            data={defaultData}
            onSuccess={onSuccess}
            request={requests.create()}
        />
    )
}

export default BillingCompanyCreate
